import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { workSchedulesService } from '../api/workSchedules.service';
import { WORK_SCHEDULES_KEYS } from './queryKeys';
import type { UpsertTenantWorkSchedulePayload } from '../types';

/**
 * Creates or updates the tenant work schedule.
 * On success, invalidates the tenant schedule query.
 */
export function useUpsertTenantWorkSchedule() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: (payload: UpsertTenantWorkSchedulePayload) =>
      workSchedulesService.upsertTenant(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WORK_SCHEDULES_KEYS.tenant(orgId) });
    },
  });
}
